"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SIGNUP_EMPLOYER_PROMOCODE_QUERY_PARAM_NAME = void 0;
var SIGNUP_EMPLOYER_PROMOCODE_QUERY_PARAM_NAME = 'promocode';
exports.SIGNUP_EMPLOYER_PROMOCODE_QUERY_PARAM_NAME = SIGNUP_EMPLOYER_PROMOCODE_QUERY_PARAM_NAME;